import * as Actions from 'reducks/pushMessage/actions'
import { initialState } from 'reducks/reduxStore/initialState'

export const PushMessageReducer = (state = initialState.pushMessage, action: any) => {
  switch (action.type) {
    case Actions.FETCH_PUSH_MESSAGES:
      return {
        ...state,
        pushMessages: [...action.payload],
      }
    default:
      return state
  }
}
